import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AnalyticsService } from '../../@core/utils';
import { STUDENT_PROGRESS } from '../../config/student_progress';
import { ClearObservableHelper } from '../../helpers/ClearObservableHelper';
import { Classroom } from '../../interface/calendar';
import { AuthService } from '../../services/auth.service';
import { PacingPlanService } from '../../services/pacing-plan.service';
import { StorageService } from '../../services/storage.service';
import { StudentService } from '../../services/student.service';
import { UtilService } from '../../services/util.service';
@Component({
  selector: 'ngx-power-up-points',
  templateUrl: './power-up-points.component.html',
  styleUrls: ['./power-up-points.component.scss'],
})
export class PowerUpPointsComponent extends ClearObservableHelper implements OnInit, OnChanges {
  loading = false;
  usersData = [];
  currentUser;
  isPaginate = true;
  currentPage = 1;
  totalPages = 1;
  @Input() isModal = false;
  @Output() closeDialogModal = new EventEmitter<boolean>();
  @Input() classroom: Classroom;
  userData: any[];
  groupedData: { [key: number]: any[] } = {};
  assessmentEvaluationData;
  correctnessCount = {};
  // mockData = true;
  mockData = this.storageService.getItem('user').user['is_trial_user'] ? true : false;

  constructor(
    public analyticsService: AnalyticsService,
    private storageService: StorageService,
    private authService: AuthService,
    private studentService: StudentService,
    private pacingPlanService: PacingPlanService,
    public router: Router,
    private spinner: NgxSpinnerService,
    private utilService: UtilService,
  ) {
    super();
  }

  async ngOnInit() {
    try {
      // this.loading = true;
      this.spinner.show();
      this.currentUser = this.storageService.getItem('user');
      if (this.classroom) await this.getStudentsByClassroomId();
      const body = {
        classroom_id: this.classroom.id,
        subject_id: this.classroom.current_subject_id,
      };
      this.assessmentEvaluationData = await this.studentService.teacherAssessmentForEvalution(body);
      this.groupDataByUserId(this.assessmentEvaluationData);
      // this.loading = false;
      this.spinner.hide();
      this.pacingPlanService.changeClassroom.subscribe(async (x: any) => {
        if (x?.id) {
          // this.loading = true;
          this.spinner.show();
          this.currentPage = 1;
          this.classroom = x;
          if (this.classroom) await this.getStudentsByClassroomId();
          const body1 = {
            classroom_id: this.classroom.id,
            subject_id: this.classroom.current_subject_id,
          };
          this.assessmentEvaluationData = await this.studentService.teacherAssessmentForEvalution(body1);
          this.groupDataByUserId(this.assessmentEvaluationData);
          this.loading = false;
        }
      });
      // subscribe the events for multi-subject classroom
      this.pacingPlanService.currentSubject.subscribe(async (x) => {
        if (x) {
          this.spinner.show();
          this.currentPage = 1;
          await this.getStudentsByClassroomId();
          const body1 = {
            classroom_id: this.classroom.id,
            subject_id: this.classroom.current_subject_id,
          };
          this.assessmentEvaluationData = await this.studentService.teacherAssessmentForEvalution(body1);
          this.groupDataByUserId(this.assessmentEvaluationData);
          this.spinner.hide();
        }
      });
    } catch (error) {
      // this.loading = false;
      this.spinner.hide();
      // console.log(error);
    }
  }

  async getStudentsByClassroomId() {
    if (this.mockData) {
      this.usersData = STUDENT_PROGRESS;
    } else {
      try {
        const params = {
          classroom_code: this.classroom.code,
          page: this.currentPage,
        };

        const response: any = await this.studentService.studentByClassroomId(params);
        this.totalPages = response?.pageTotal;
        this.usersData = [];

        if (response?.items?.length > 0) {
          this.usersData = response?.items;
          await this.getPowerUpPointsByRoleId(response.items);
        }
      } catch (error) {
        // console.log(error);
      }
    }
  }

  async getPowerUpPointsByRoleId(studentsRecords) {
    try {
      const body = {
        student_ids: studentsRecords.map((x) => x.user_id),
      };

      const response = await this.authService.powerUpPointsByStudentIds(body);

      await this.getTotalPowerUpPoints(response);
      await this.updateStudentPowerUpPoints();
    } catch (error) {
      // console.log(error);
    }
  }

  async getTotalPowerUpPoints(students) {
    try {
      this.usersData.map(async (x) => {
        const powerUpPoints = students?.filter((stud) => stud?.user_id === x?.user_id)[0];
        x.studentId = x?.id;
        if (powerUpPoints?.points?.length > 0) {
          x.points = powerUpPoints?.points;
          let totalPowerUpPoints = 0;
          powerUpPoints?.points?.forEach((element) => {
            totalPowerUpPoints += element.points;
          });

          x['total_power_up_points'] = totalPowerUpPoints;
        } else {
          x['total_power_up_points'] = 0;
        }

        return x;
      });
    } catch (error) {
      // console.log(error);
    }
  }
  async updateStudentPowerUpPoints() {
    try {
      this.usersData.map((user) => {
        user['powerUpPointsByAiLength'] = user?.points?.filter((x) => x.type === 1);
        let pointsByAi = 0;
        user['powerUpPointsByAiLength']?.length > 0
          ? user['powerUpPointsByAiLength'].forEach((element) => {
              pointsByAi += element.points;
            })
          : null;

        user['powerUpPointsByAi'] = pointsByAi;

        user['powerUpPointsByTeacherLength'] = user?.points?.filter((x) => x.type === 2);
        let pointsByTeacher = 0;

        user['powerUpPointsByTeacherLength']?.length > 0
          ? user['powerUpPointsByTeacherLength'].forEach((element) => {
              pointsByTeacher += element.points;
            })
          : null;

        user['powerUpPointsByTeacher'] = pointsByTeacher;

        user['powerUpPointsByStudentLength'] = user?.points?.filter((x) => x.type === 3);
        let pointsByStudent = 0;

        user['powerUpPointsByStudentLength']?.length > 0
          ? user['powerUpPointsByStudentLength'].forEach((element) => {
              pointsByStudent += element.points;
            })
          : null;

        user['powerUpPointsByStudent'] = pointsByStudent;

        user['powerUpPointsByHelpingStudentLength'] = user?.points?.filter((x) => x.type === 4);
        let pointsByHelpingStudents = 0;

        user['powerUpPointsByHelpingStudentLength']?.length > 0
          ? user['powerUpPointsByHelpingStudentLength'].forEach((element) => {
              pointsByHelpingStudents += element.points;
            })
          : null;

        user['pointsByHelpingStudents'] = pointsByHelpingStudents;
      });
    } catch (error) {
      // console.log(error);
    }
  }
  async getUsers(isNext = false) {
    try {
      this.loading = true;

      this.analyticsService.trackEvent('Get Users', 'Power Up Points');
      isNext ? this.currentPage++ : this.currentPage--;
      await this.getStudentsByClassroomId();

      this.loading = false;
    } catch (error) {
      this.loading = false;
      // console.log(error);
    }
  }

  async closeDialog() {
    try {
      this.closeDialogModal.emit(true);
    } catch (error) {
      // console.log(error);
    }
  }

  public studentDetails(id: number, user_id: number, assessmentProgress?): void {
    if (this.isModal) this.closeDialog();
    this.router.navigateByUrl(
      `test-quizzes/student-detail/${id}/${this.classroom.id}/${this.isModal}/${assessmentProgress}/${user_id}`,
    );
  }
  private groupDataByUserId(userData) {
    this.correctnessCount = {};
    this.groupedData = {};

    userData.assessment_total_student_evaluation.forEach((entry) => {
      const userId = entry.user_id;
      if (!this.groupedData[userId]) {
        this.groupedData[userId] = [];
      }
      this.groupedData[userId].push(entry);
    });
    for (const userId in this.groupedData) {
      if (this.groupedData.hasOwnProperty(userId)) {
        const userEntries = this.groupedData[userId];
        const userCorrectnessCount = userEntries.reduce((count, entry) => {
          return count + (entry.correctness ? 1 : 0);
        }, 0);
        // Store the result
        this.correctnessCount[userId] = userCorrectnessCount;
      }
    }
    // console.log(this.correctnessCount);
  }

  getStatusClass(value: number): string {
    return this.utilService.getStatusClass(value);
  }
  /**
   * @description On input changes, fetch students if classroom input changes.
   * @param changes - SimpleChanges
   */
  async ngOnChanges(changes: SimpleChanges) {
    try {
      if (changes['classroom']) {
        // this.spinner.show();
        this.currentPage = 1;
        if (this.classroom) await this.getStudentsByClassroomId();
        const body1 = {
          classroom_id: this.classroom.id,
          subject_id: this.classroom.current_subject_id,
        };
        this.assessmentEvaluationData = await this.studentService.teacherAssessmentForEvalution(body1);
        this.groupDataByUserId(this.assessmentEvaluationData);
        // this.spinner.hide();
      }
    } catch (error) {
      console.log('PowerUpPointsComponent ~ ngOnChanges ~ error:', error);
    }
  }
}
